import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Sporting Clays Shot Tracker</h1>
        <p>Welcome to the Sporting Clays Shot Tracker app! This app helps you track your shot performance. If you need any assistance or have questions, please feel free to reach out using the contact details below.</p>
        
        <section className="Support-info">
          <h2>Support</h2>
          <p>If you're experiencing issues or have questions, don't hesitate to get in touch:</p>
          <p><strong>Support Email:</strong> <a href="mailto:sendit2theinternet@gmail.com">sendit2theinternet@gmail.com</a></p>
          <p>We'll get back to you as soon as possible to help resolve any issues or provide guidance on how to use the app effectively.</p>
        </section>

        <section className="App-footer">
          <p>Thank you for using the Sporting Clays Shot Tracker!</p>
          <p>© 2025 Sporting Clays Shot Tracker</p>
        </section>
      </header>
    </div>
  );
}

export default App;
